import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { CollaborationStepContainer } from 'features/collaboration-base/components';
import {
  cancelTeamingRequest,
  isHandoffSelector,
  teamingAcceptingUserSelector,
} from 'features/teaming/teaming-base/store';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Button } from 'features/ui/elements';

interface TeamBaseAcceptedProps {
  onStartTeamingClick: () => void;
}

export const TeamingBaseAccepted: FC<TeamBaseAcceptedProps> = ({
  onStartTeamingClick,
}) => {
  const dispatch = useAppDispatch();
  const { t: ct } = useTranslation();
  const { t } = useTranslation('translation', {
    keyPrefix: 'teamAccepted',
  });
  const isHandoff = useAppSelector(isHandoffSelector);
  const acceptingUser = useAppSelector(teamingAcceptingUserSelector);

  // TODO: split presentation component on TeamAccepted and HandoffAccepted
  const startTeamingButtonText = t(isHandoff ? 'startHandoff' : 'startTeaming');

  const handleCancel = () => {
    dispatch(cancelTeamingRequest());
  };

  return (
    <CollaborationStepContainer testId='teaming-accepted'>
      {/* TODO: update text styles when Doug finish it in Figma */}
      <Typography variant='body1' color={theme.palette.grey[50]}>
        {t('userAvailableToJoin', {
          userNumber: acceptingUser.number,
          userName: acceptingUser.name,
        })}
      </Typography>
      <StartTeamingButton
        type='submit'
        color='primary'
        size='small'
        fullWidth
        data-testid='start-teaming'
        title={startTeamingButtonText}
        onClick={onStartTeamingClick}
        autoFocus
      >
        {startTeamingButtonText}
      </StartTeamingButton>
      <CancelButton
        fullWidth
        color='secondary'
        size='small'
        title={ct('cancel')}
        onClick={handleCancel}
      >
        {ct('cancel')}
      </CancelButton>
    </CollaborationStepContainer>
  );
};

const StartTeamingButton = styled(Button)`
  margin-top: ${theme.spacing(8)};
`;

const CancelButton = styled(Button)`
  margin-top: ${theme.spacing(4)};
`;
